export default __webpack_public_path__ + "static/after-support-thumbnail-third-843da6a425ff432e4fbb8976a50c4ee7.png";